async function netRequestsOffline() {
  const PROGRAMS = {
    operator: "TGU",
    DPO: {
      json: "",
    },
    PO: {
      fetch:
        "https://2025.api.tgu-dpo.ru/regions/GetAllProgramsWithRegions?isShowTgu=true&isVisibleWithoutDirection=true&withoutEducation=true&exceptOffline=false&exceptOnline=true",
      json: "/files/Programs.json",
    },
  };

  async function operatorPrograms(Operator) {
    let arr = [];

    let dpo_json = await getJson(Operator.DPO.json),
      po_fetch = await getJson(Operator.PO.fetch),
      po_json = await getJson(Operator.PO.json);

    addPropertyProgram(dpo_json, arr, Operator);
    addPropertyProgram(po_fetch, arr, Operator, "po");
    addPropertyProgram(po_json, arr, Operator, "po");

    /* Добавление регионов для программ с редиректом */
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].shortName === arr[j].shortName) {
          arr[i].regions = arr[i].regions.concat(arr[j].regions);
        }
      }
    }

    /* Удаление дублей программ */
    arr = arr.filter(
      (item, idx, arr) =>
        arr.findIndex((el) => el.shortName === item.shortName) == idx
    );

    /* Добавление городов */
    for (let item of arr) {
      for (let i = 0; i < item.regions.length; i++) {
        for (let j = i + 1; j < item.regions.length; j++) {
          if (item.regions[i].regionId === item.regions[j].regionId) {
            item.regions[i].cities = item.regions[i].cities.concat(item.regions[j].cities);
            item.regions[j].dublicate = true;
          }
        }
      }
    }

    /* Удаление дублей регионов */
    for (let item of arr) {
      item.regions = item.regions.filter((item) => item.dublicate != true);
    }
    
    return arr;
  }

  /* Добавление свойств для программ */
  function addPropertyProgram(programs, array, Operator, status = "dpo") {
    if (programs) {
      programs.map((item) => {
        item.operator = Operator.operator;

        if (status == "po") {
          item.po = true;
        }

        /* Удаление регионов с отсутствием городов */
        let result = item.regions.filter(region => region.cities.length > 0);
        item.regions = [];
        item.regions = result;
      });

      array.push(...programs);
    }
  }

  /* Запрос на получение json */
  async function getJson(patch) {
    if (!patch) return;

    let response = await fetch(patch);
    let result = await response.json();

    return result;
  }

  return await operatorPrograms(PROGRAMS);
}

export default netRequestsOffline;
